import React from 'react';
import { onMessage } from 'firebase/messaging';
import { Box, IconButton, Typography } from '@material-ui/core';
import { Cancel } from '@material-ui/icons';
import { useSnackbar } from 'notistack';
import { messaging } from 'firebaseInit';

import { urlify } from 'helper';

export interface PushNotificationProps {}

const PushNotification: React.FC<PushNotificationProps> = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  onMessage(messaging, ({ notification }) => {
    enqueueSnackbar(
      <Box sx={{ maxWidth: 530 }}>
        <Typography component="p" variant="h6">
          {notification?.title}
        </Typography>

        <Typography
          component="p"
          variant="body1"
          dangerouslySetInnerHTML={{ __html: urlify(String(notification?.body)) }}
        />
      </Box>,
      {
        variant: 'success',
        autoHideDuration: 10000,
        action: () => (
          <IconButton onClick={() => closeSnackbar()}>
            <Cancel color="action" />
          </IconButton>
        ),
      },
    );
  });

  return <></>;
};

export default PushNotification;
